/* TRATANTE® — página A Marca: manifesto palavra a palavra, arquivo em pilha, antes/depois, galeria horizontal */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const page = $('#brandPage'); if (!page) return;
  const pad = n => String(n).padStart(2, '0');

  // entradas ao aparecer (passos e fecho sublinhado)
  if (!('IntersectionObserver' in window) || RM) { $$('#brandPage [data-rev], #bpNever li').forEach(e => e.classList.add('in')); }
  else {
    const o = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { const els = e.target.id === 'bpNever' ? $$('li', e.target) : [e.target]; els.forEach((x, i) => setTimeout(() => x.classList.add('in'), i * 220)); o.unobserve(e.target); } }), { threshold: .35 });
    $$('#brandPage [data-rev]').forEach(e => o.observe(e)); const nv = $('#bpNever'); if (nv) o.observe(nv);
  }

  // antes / depois
  const ba = $('#ba');
  if (ba) {
    const set = v => { v = Math.max(0, Math.min(100, v)); ba.style.setProperty('--x', v + '%'); ba.setAttribute('aria-valuenow', Math.round(v)); };
    let drag = false;
    const at = e => { const r = ba.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); };
    ba.addEventListener('pointerdown', e => { drag = true; ba.setPointerCapture(e.pointerId); at(e); });
    ba.addEventListener('pointermove', e => { if (drag) at(e); });
    ba.addEventListener('pointerup', () => drag = false); ba.addEventListener('pointercancel', () => drag = false);
    ba.addEventListener('keydown', e => { const v = parseFloat(ba.getAttribute('aria-valuenow')); if (e.key === 'ArrowLeft') { e.preventDefault(); set(v - 5); } if (e.key === 'ArrowRight') { e.preventDefault(); set(v + 5); } });
    set(50);
    if (!RM && 'IntersectionObserver' in window) {
      const o = new IntersectionObserver(es => {
        if (!es[0].isIntersecting) return; o.disconnect();
        const t0 = performance.now(), seq = [[0, 50], [700, 82], [1500, 18], [2200, 50]];
        const step = now => { if (drag) return; const t = now - t0; let k = 0; while (k < seq.length - 1 && t > seq[k + 1][0]) k++; if (k >= seq.length - 1) { set(50); return; }
          const [ta, va] = seq[k], [tb, vb] = seq[k + 1], p = (t - ta) / (tb - ta), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; set(va + (vb - va) * e); requestAnimationFrame(step); };
        requestAnimationFrame(step);
      }, { threshold: .6 });
      o.observe(ba);
    }
  }

  // scroll: parallax, pilha, manifesto, galeria horizontal
  function brandScroll() {
    if (!RM) $$('#brandPage .bleed img').forEach(img => { const r = img.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; const t = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; img.style.transform = `translate3d(0,${(-t * 50).toFixed(1)}px,0)`; });
    const stk = $('#bpStack');
    if (stk) {
      const r = stk.getBoundingClientRect(), tot = r.height - innerHeight;
      const pr = Math.min(1, Math.max(0, -r.top / (tot || 1)));
      const figs = $$('#pile figure'), n = figs.length, f = pr * (n - 1);
      figs.forEach((fg, i) => {
        if (i === 0) { fg.style.transform = `rotate(${fg.dataset.r}deg)`; return; }
        const t = Math.min(1, Math.max(0, f - (i - 1))), e = 1 - Math.pow(1 - t, 3);
        fg.style.transform = `translate3d(0,${((1 - e) * innerHeight * 1.05).toFixed(1)}px,0) rotate(${(fg.dataset.r * e).toFixed(2)}deg)`;
      });
      const k = Math.min(n - 1, Math.round(f)), cap = $('#stackCap');
      if (cap && figs[k] && cap.dataset.k != k) { cap.dataset.k = k; cap.textContent = figs[k].dataset.cap; $('#stackN').textContent = `${pad(k + 1)} / ${pad(n)}`; }
    }
    const man = $('#bpMan');
    if (man) {
      const r = man.getBoundingClientRect(), tot = r.height - innerHeight * .9;
      const pr = Math.min(1, Math.max(0, (-r.top + innerHeight * .15) / (tot || 1)));
      const ws = $$('.w', man), f = Math.min(1, pr / 0.8) * (ws.length + 1.2);
      ws.forEach((w, i) => {
        let t = RM ? 1 : Math.min(1, Math.max(0, (f - i) / 1.6)); t = t * t * (3 - 2 * t);
        w.style.opacity = (0.06 + 0.94 * t).toFixed(3);
        w.style.transform = `translate3d(0,${((1 - t) * 0.22).toFixed(3)}em,0)`;
        w.style.filter = t >= 1 ? 'none' : `blur(${((1 - t) * 5).toFixed(2)}px)`;
        w.classList.toggle('on', t > 0.95);
      });
    }
    const hz = $('#bpHz'), tr = $('#bpTrack');
    if (hz && tr) {
      const rh = hz.getBoundingClientRect(), th = rh.height - (innerHeight - 60);
      const ph = Math.min(1, Math.max(0, -rh.top / (th || 1)));
      const max = tr.scrollWidth - innerWidth + 16;
      tr.style.transform = `translate3d(${(-ph * Math.max(0, max)).toFixed(1)}px,0,0)`;
      const pg = $('#bpProg'); if (pg) pg.style.width = (ph * 100).toFixed(1) + '%';
    }
  }
  // avaliações do Google: só carrega quando a secção se aproxima do ecrã (cada pedido conta na quota da Google)
  const rev = $('#bpRev');
  if (rev && rev.dataset.key && rev.dataset.place) {
    const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const stars = n => { const r = Math.round(n || 0); return '★'.repeat(r) + '☆'.repeat(Math.max(0, 5 - r)); };
    const txt = v => (v && typeof v === 'object' ? (v.text || '') : (v || ''));
    const loadLive = async () => {
      try {
        if (!(window.google && google.maps && google.maps.importLibrary)) {
          await new Promise((ok, ko) => {
            window.__trtMaps = ok;
            const s = document.createElement('script');
            s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(rev.dataset.key)}&v=weekly&loading=async&language=${encodeURIComponent(document.documentElement.lang || "pt-PT")}&callback=__trtMaps`;
            s.async = true; s.onerror = ko; document.head.appendChild(s);
          });
        }
        const { Place } = await google.maps.importLibrary('places');
        const p = new Place({ id: rev.dataset.place, requestedLanguage: 'pt-PT' });
        await p.fetchFields({ fields: ['rating', 'userRatingCount', 'reviews', 'googleMapsURI'] });
        const sc = $('.rev-score', rev);
        if (p.rating) { $('#revRating').textContent = String(p.rating.toFixed(1)).replace('.', ','); $('#revCount').textContent = `${p.userRatingCount} ${__('avaliações')}`; if (sc) sc.hidden = false; }
        const list = (p.reviews || []).filter(r => txt(r.text).trim());
        if (list.length) $('#revTrack').innerHTML = list.map(r => {
          const a = r.authorAttribution || {};
          return `<figure class="rev"><span class="rev-stars" aria-label="${r.rating} ${__('de 5 estrelas')}">${stars(r.rating)}</span><blockquote>${esc(txt(r.text))}</blockquote><figcaption class="mono">${a.uri ? `<a href="${esc(a.uri)}" target="_blank" rel="noopener">${esc(a.displayName)}</a>` : esc(a.displayName || '')}${r.relativePublishTimeDescription ? ' · ' + esc(r.relativePublishTimeDescription) : ''}</figcaption></figure>`;
        }).join('');
        const lk = $('#revLink'); if (lk && lk.hidden && p.googleMapsURI) { lk.href = p.googleMapsURI; lk.hidden = false; }
      } catch (e) { /* sem ligação à Google: ficam as avaliações manuais, se existirem */ }
    };
    if ('IntersectionObserver' in window) { const o = new IntersectionObserver(es => { if (es[0].isIntersecting) { o.disconnect(); loadLive(); } }, { rootMargin: '800px 0px' }); o.observe(rev); } else loadLive();
  }

  let tk = false;
  const onS = () => { if (tk) return; tk = true; requestAnimationFrame(() => { tk = false; brandScroll(); }); };
  addEventListener('scroll', onS, { passive: true });
  addEventListener('resize', onS);
  brandScroll();
})();
